import React from 'react';
import PropTypes from 'prop-types';
import CredentialBoxWrapper from '../../layouts/CredentialBoxWrapper';
import LoginBox from '../../components/LoginBox';
import loginEnhancer from '../../../common/containers/LoginEnhancer';
import ContinueAs from '../../../common/containers/ContinueAsContainer';

export const Login = ({ handleOnInputChange, message, handleOnLogin, credentials }) => (
  <CredentialBoxWrapper>
    <LoginBox
      credentials={credentials}
      onInputChange={handleOnInputChange}
      onLogin={handleOnLogin}
      message={message}
    />
    <ContinueAs />
  </CredentialBoxWrapper>
);

Login.propTypes = {
  handleOnInputChange: PropTypes.func.isRequired,
  handleOnLogin: PropTypes.func.isRequired,
  credentials: PropTypes.shape({
    username: PropTypes.string,
    password: PropTypes.string
  }).isRequired,
  message: PropTypes.string
};

Login.defaultProps = {
  message: null
};

export default loginEnhancer(Login);



// WEBPACK FOOTER //
// ./src/views/officials-connect/pages/Login/index.jsx